import { render } from "./live-scoring.vue?vue&type=template&id=32c028d5&scoped=true"
import script from "./live-scoring.vue?vue&type=script&lang=js"
export * from "./live-scoring.vue?vue&type=script&lang=js"

import "./live-scoring.vue?vue&type=style&index=0&id=32c028d5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32c028d5"]])

export default __exports__